import { render } from "./LicenseLog.vue?vue&type=template&id=0a066642&scoped=true"
import script from "./LicenseLog.vue?vue&type=script&lang=js"
export * from "./LicenseLog.vue?vue&type=script&lang=js"

import "./LicenseLog.vue?vue&type=style&index=0&id=0a066642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a066642"]])

export default __exports__